import axios from 'axios'

/**
 * ⚠️ DEAD UPSTREAM — DO NOT WIRE NEW FEATURES / NOT E2E-COVERED BY DESIGN.
 *
 * Every method below targets the external Stripe-backed micro-services via
 * `VITE_PRODUCT_SERVICE_URL` / `VITE_AUTH_SERVICE_URL`. Those API Gateway
 * endpoints were DELETED and now resolve to NXDOMAIN — the whole
 * subscription/SNS pipeline was torn down (see the api-laravel
 * `AuthController` + `UserAdmin::isUserTrial` docblocks; trial state now
 * resolves purely on `institution.client.paying`). The UI is only reachable
 * for a non-paying institution owner, and every call here fails at the network.
 *
 * Kept only because the `src/components/subscriptions/*` views still import it;
 * intentionally excluded from the e2e suite (nothing live to assert against).
 * Remove once the subscriptions UI is deleted or a replacement service lands.
 */
export default {
    async getLearnUToken() {
        return await axios.post(`${import.meta.env.VITE_AUTH_SERVICE_URL}/token`, {
            
            data: {
                type: "token",
                attributes: {
                    learnuToken: localStorage.getItem('id_token'),
                    shortLived: true
                }
            }

        })
    },
    async getProducts() {
        return await axios.get(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/products?filter[app]=learnu&filter[paymentProcessor]=stripe-learnu`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        })
    },

    async getStripeKey() {
        return await axios.get(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/payment-processors/stripe-learnu`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        })
    },

    async savePaymentMethod(id) {
        if(!id) return 0
        return await axios.post(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/payment-methods`,
            {
                data: {
                    type: "payment-method",
                    attributes: {
                        app: "learnu",
                        paymentProcessor: "stripe-learnu",
                        dataForPaymentProcessor: {
                            stripePaymentMethodId: id,
                            createStripeSetupIntent: true
                        }
                    }
                }
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                },
                
            }
        )
    },

    async createSubscription({ product, price, paymentMethod }) {
        if(!product || !price || !paymentMethod) return 0
        return await axios.post(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/subscriptions`,
            {
                data: {
                    type: "subscription",
                    attributes: {
                        paymentProcessor: "stripe-learnu",
                        product,
                        price,
                        paymentMethod
                    }
                }
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                }
            }
        )
    },

    async getActiveSubscriptions() {
        return await axios.get(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/subscriptions?filter[status]=active&filter[app]=learnu`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        })
    },

    async getActivePaymentMethods() {
        return await axios.get(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/payment-methods?filter[status]=active`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                },
            }
        )
    },

    async unsubscribe(subscribsionId) {
        if(!subscribsionId) return
        return await axios.post(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/subscriptions/cancel`,
            {
                "data":
                {
                    "type": "subscription-cancel-request",
                    "attributes":
                    {
                        "subscription": subscribsionId
                    }
                }
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                }
            }
        )
    },

    async cancelSubscriptionAnswer(message) {
        if (!message) return ''
        return await axios.post(`/subscription-cancel-poll`,
            {
                message
            }
        )
    },

    async migrateToSubscription({ subscription, product, price, paymentMethod }) {
        if(!subscription || !product || !price || !paymentMethod) return 0
        return await axios.post(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/subscriptions/migrate`,
            {
                'data':
                {
                    type: 'migrate-subscription-request',
                    attributes:
                    {
                        subscription,
                        product,
                        price,
                        paymentMethod
                    }
                }
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                }
            }
        )
    },
    async getBillingHistory() {
        return await axios.get(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/payment-journal/entries?view=learnu&filter[app]=learnu&filter[paymentProcessor]=stripe-learnu`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                }
            }
        )
    },
    async getFutureSubscriptions() {
        return await axios.get(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/future-subscriptions`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                }
            }
        )
    },
    async deactivatePaymentMethod(paymentMethod) {
        if(!paymentMethod) return
        return await axios.post(`${import.meta.env.VITE_PRODUCT_SERVICE_URL}/payment-methods/disable`,
            {
                data: {
                    type: "payment-method-disable-request",
                    attributes: {
                        paymentMethod
                    }
                }
            },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                }
            }
        )
    },
}